import { css } from '@emotion/react';

import {
  black,
  blue5,
  gray3,
  gray4,
  gray5,
  gray7,
  primary,
  successHover,
  white,
} from 'styles/global_defaults/colors';
import {
  semiBoldFontWeight,
  textLargeBodyFontSize,
  textLargeLineHeight,
  textMediumFontSize,
  textSmallFontSize,
} from 'styles/global_defaults/fonts';
import {
  halfSpacing,
  largeSpacing,
  quarterSpacing,
  threeQuartersSpacing,
} from 'styles/global_defaults/scaffolding';

export const modalStyles = css`
  .bs4-modal-content {
    height: auto !important;
  }

  .bs4-modal-body {
    padding: ${largeSpacing}px !important;
    padding-top: 0 !important;
    max-height: none !important;
    overflow: visible !important;
  }
`;

export const bodyStyles = (isCollection: boolean, isLinked: boolean) => css`
  input[type='radio'] + label::before {
    border-width: 2px;
  }

  .selection {
    flex-grow: 1;
    width: 100%;

    .option {
      padding: ${threeQuartersSpacing}px;
      border-radius: ${quarterSpacing}px;
      background-color: ${gray7};
      border: 1px solid transparent;
      margin-top: 0;
      margin-bottom: 0;

      > div {
        margin-top: 0;
        margin-bottom: 0;
      }

      & + .option {
        margin-top: ${threeQuartersSpacing}px;
      }

      label {
        cursor: pointer !important;
        font-size: ${textLargeBodyFontSize}px;
        line-height: ${textLargeLineHeight}px;
        margin-bottom: 0;
        color: ${isCollection ? gray3 : black};
      }

      &.selected {
        border-color: ${isCollection ? gray3 : primary};
        background-color: ${isCollection ? gray7 : blue5};

        label {
          ::before {
            border-color: ${isCollection ? gray3 : primary};
            background-color: ${isCollection ? gray3 : primary};
          }
        }
      }
    }
  }

  .content-options {
    width: 100%;
    max-height: 0;
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.3s ease, margin-top 0.3s ease,
      visibility 0s linear 0.4s;

    &.open {
      max-height: 1000px;
      opacity: 1;
      visibility: visible;
      margin-top: ${threeQuartersSpacing}px;
      transition: max-height 0.4s ease, opacity 0.3s ease, margin-top 0.3s ease,
        visibility 0s linear 0s;
    }

    .content-options-inner {
      background-color: ${gray7};
      border: 1px solid ${gray5};
      border-radius: ${quarterSpacing}px;
      padding: ${threeQuartersSpacing}px;
    }

    .content-options-title {
      font-size: ${textLargeBodyFontSize}px;
      margin-bottom: ${threeQuartersSpacing}px;
    }

    .content-option {
      padding: ${quarterSpacing}px ${threeQuartersSpacing}px
        ${threeQuartersSpacing}px ${threeQuartersSpacing}px;
      border-radius: ${quarterSpacing}px;
      border: 1px solid ${gray4};

      & + .content-option {
        margin-top: ${threeQuartersSpacing}px;
      }

      label {
        color: ${isLinked ? gray3 : black};
        cursor: pointer !important;
        font-size: ${textLargeBodyFontSize}px;
        line-height: ${textLargeLineHeight}px;
        margin-bottom: 0;
      }

      .description {
        margin-top: ${quarterSpacing}px;
        margin-bottom: 0;
        font-size: ${textMediumFontSize}px;
        color: ${black};
      }

      .textarea-reveal {
        max-height: 0;
        opacity: 0;
        visibility: hidden;
        overflow: hidden;
        transition: max-height 0.3s ease, opacity 0.25s ease,
          margin-top 0.25s ease, visibility 0s linear 0.3s;

        &.open {
          max-height: 600px;
          opacity: 1;
          visibility: visible;
          overflow: visible;
          margin-top: ${threeQuartersSpacing}px;
          transition: max-height 0.3s ease, opacity 0.25s ease,
            margin-top 0.25s ease, visibility 0s linear 0s;
        }

        textarea {
          min-height: 200px;
          max-height: 400px;
          background-color: ${white};
          border-radius: ${quarterSpacing}px !important;
          padding-right: ${largeSpacing}px;
          resize: vertical;
          border: 1px solid ${gray3} !important;
        }

        .bs4-input-group {
          position: relative;
        }

        .bs4-input-group-append {
          &:last-child {
            position: absolute;
            top: ${halfSpacing}px;
            right: ${threeQuartersSpacing}px;

            .bs4-input-group-text {
              background-color: transparent;
              border: none;
              padding: 0;
            }
          }

          &:not(:last-child) .bs4-input-group-text {
            align-items: flex-start;
            padding-top: ${halfSpacing}px;
            background-color: ${white};
          }
        }

        .word-count {
          margin-top: ${quarterSpacing}px;
          font-weight: ${semiBoldFontWeight};
          margin-bottom: 0;
          color: ${isLinked ? gray3 : black};
          font-size: ${textSmallFontSize}px;

          .icon {
            display: inline;
          }

          .count.met,
          .icon.met {
            color: ${isLinked ? gray3 : successHover};
          }
        }
      }

      &.selected {
        border-color: ${isLinked ? gray4 : primary};
        background-color: ${isLinked ? gray7 : blue5};

        label {
          ::before {
            border-color: ${isLinked ? gray3 : primary};
            background-color: ${isLinked ? gray3 : primary};
          }
        }
      }
    }
  }
`;
